import React, { Component } from 'react';

/**
 * Renders: props.children 
 * @props {Object} children
 */
class LoginOverlayParent extends Component {
	render() {
		return <div className="pt-overlay-content login_popover">
			{this.props.children}
		</div>
	}
}

export default LoginOverlayParent;


// WEBPACK FOOTER //
// ./src/components/login/LoginOverlayParent.js